<template>
  <div class="helpCenter">
    <!-- 标题栏 -->
    <van-nav-bar left-arrow title="帮助中心" @click-left="onClickLeft" />
    <!-- 内容 -->
    <van-cell-group>
      <van-field v-model="message" rows="2" autosize type="textarea" maxlength="200" placeholder="请输入留言" show-word-limit />
    </van-cell-group>
    <!-- 图片上传 -->
    <van-uploader v-model="fileList" :max-count="4" multiple>
      <div class="uploadImg upload-img-btn"></div>
    </van-uploader>
    <div class="TimUi-submit">
      <button class="TimUi-btn TimUi-btn-block bgC-F82E3D" @click='submitFeedback'>提交反馈</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'helpCenter',
  data () {
    return {
      message: '',
      // fileList: [
      //   { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
      //   // Uploader 根据文件后缀来判断是否为图片文件
      //   // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
      //   { url: 'https://cloud-image', isImage: true }
      // ]
      fileList: []
    }
  },
  created () {

  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    submitFeedback () { }
  }
}
</script>
<style>
.van-field__word-limit {
  text-align: left;
}
.van-uploader__preview-image {
  width: 60px;
  height: 60px;
}
</style>
<style lang="scss" scoped>
.van-cell-group {
  padding: 15px 15px 0 15px;
  .van-cell {
    background: rgba(248, 251, 255, 1);
    .van-cell__value.van-cell__value--alone {
      min-height: 172px;
      .van-field__control {
        max-height: 172px;
      }
    }
  }
}
.van-hairline--top-bottom::after {
  border: 0;
}
.van-uploader {
  display: block;
  padding: 15px 15px 0 15px;
  .upload-img-btn {
    position: relative;
    width: 60px;
    height: 60px;
    border-radius: 5px;
    background-color: #f8fbff;
  }

  .upload-img-btn:before {
    content: "+";
    position: absolute;
    left: 50%;
    top: 50%;
    font-size: 32px;
    transform: translate(-50%, -50%);
    color: #999999;
  }
}

.TimUi-submit {
  position: fixed;
  bottom: 30px;
  left: 30px;
  right: 30px;
  .TimUi-btn-block {
    width: 100%;
    height: 100px;
    margin: 0;
    padding: 0;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 23px 1px rgba(150, 174, 206, 0.63);
    border-radius: 50px;
  }
}
</style>
